<template>

    <transition name="modal">
        <div class="vgs" @click="close" v-if="imgIndex !== null">
            <button type="button" class="vgs__close" @click="close">&times;</button>
            <button type="button" class="vgs__prev" v-if="isMultiple" @click.stop="onPrev">&lsaquo;</button>
            <div class="vgs__container" v-if="images" @click.stop>
                <div class="row">
                    <div class="col-sm-3">
                        <div class="box box-primary">
                            <div class="box-header">
                                <h2 class="box-title">Sizes</h2>
                            </div>
                            <div class="box-body">
                                <div class="sizes">
                                    <a v-for="sz in currentImage.sizes" @click.stop="showSize(sz)" :class="{'active':sz.size === size}">
                                        {{ upperFirst(sz.size) }}
                                    </a>
                                </div>
                                <div>
                                    <div class="input-group input-group-sm">
                                        <input type="text" class="form-control" v-model="currentSize.networkpath" disabled />
                                        <span class="input-group-btn">
                                            <button type="button" class="btn btn-info btn-flat"
                                                v-clipboard:copy="currentSize.networkpath"
                                                v-clipboard:success="onCopy"
                                            >Kopieer</button>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="box box-info">
                            <div class="box-header">
                                <h2 class="box-title">Info</h2>
                            </div>
                            <div class="box-body no-padding">
                                <table class="table table-striped table-hover">
                                    <tbody>
                                        <tr>
                                            <th>Afbeelding</th>
                                            <td>{{ currentImage.name }}</td>
                                        </tr>
                                        <tr>
                                            <th>Toegevoegd door</th>
                                            <td>{{ currentImage.creator }}</td>
                                        </tr>
                                        <tr>
                                            <th>Toegevoegd op</th>
                                            <td>{{ currentImage.created_at }}</td>
                                        </tr>
                                        <tr>
                                            <th>Afbeelding genomen op</th>
                                            <td>{{ currentImage.taken_at }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-9">
                        <div class="vgs__container__section" @click.stop="onNext">
                            <img class="vgs__container__img" @click.stop="onNext" :src="imageUrl">
                        </div>
                    </div>
                </div>
            </div>
            <button type="button" class="vgs__next" v-if="isMultiple" @click.stop="onNext">&rsaquo;</button>
            <div class="vgs__gallery" v-if="isMultiple" ref="gallery">
                <div class="vgs__gallery__title" v-if="images">{{ imgIndex + 1 }} / {{ images.length }}</div>
                <div
                    class="vgs__gallery__container"
                    v-if="images"
                    :style="{ transform: 'translate(' + galleryXPos + 'px, 0)' }"
                >
                    <img
                        class="vgs__gallery__container__img"
                        v-for="(image, i) in images"
                        :src="image.url"
                        @click.stop="onClickThumb(image, i)"
                        :key="i"
                        :class="{ 'vgs__gallery__container__img--active': i === imgIndex}"
                    >
                </div>
            </div>
        </div>
    </transition>

</template>

<script>

    /*
     |
     |  This is a copy of the `vue-gallery-slideshow` package component with our own modifications.
     |
     */
    import _ from 'lodash';
    import VueClipboard from 'vue-clipboard2';
    import Vue from 'vue';

    VueClipboard.config.autoSetContainer = true;
    Vue.use(VueClipboard);

    export default {

        computed: {
            currentImage() {
                return this.images[this.imgIndex];
            },
            currentSize() {
                if (this.size === null) {
                    return this.currentImage.sizes[0];
                }
                return this.currentImage.sizes[this.currentImage.sizes.findIndex(sz => sz.size === this.size)];
            },
            imageUrl() {
                return this.currentSize.url;
            },
            isMultiple() {
                return this.images.length > 1;
            }
        },

        data() {
            return {
                imgIndex: this.index,
                image: null,
                galleryXPos: 0,
                thumbnailWidth: 120,
                size:null,
            };
        },

        mounted() {
            window.addEventListener("keydown", e => {
                if (e.keyCode === 37) {
                    this.onPrev();
                }

                if (e.keyCode === 39) {
                    this.onNext();
                }
            });
        },

        methods: {
            close() {
                this.imgIndex = null;
                this.$emit("close");
            },
            onPrev() {
                if (this.imgIndex === null) return;
                if (this.imgIndex > 0) {
                    this.imgIndex--;
                } else {
                    this.imgIndex = this.images.length - 1;
                }
                this.updateThumbails();
            },
            onNext() {
                if (this.imgIndex === null) return;
                if (this.imgIndex < this.images.length - 1) {
                    this.imgIndex++;
                } else {
                    this.imgIndex = 0;
                }
                if (this.imgIndex >= this.images.length - 11) {
                    this.$emit("reaching-the-end");
                }
                this.updateThumbails();
            },
            onClickThumb(image, index) {
                this.imgIndex = index;
                this.updateThumbails();
            },

            onCopy() {
                this.$snotify.success("Het pad naar de afbeelding is gekopieerd");
            },
            showSize(size) {
                this.size = size.size;
            },
            updateThumbails() {
                if (!this.$refs.gallery) {
                    return;
                }

                const galleryWidth = this.$refs.gallery.clientWidth;
                const currThumbsWidth = this.imgIndex * this.thumbnailWidth;
                const maxThumbsWidth = this.images.length * this.thumbnailWidth;
                const centerPos =
                    Math.floor(galleryWidth / (this.thumbnailWidth * 2)) *
                    this.thumbnailWidth;

                // Prevent scrolling of images if not needed
                if (maxThumbsWidth < galleryWidth) {
                    return;
                }

                if (currThumbsWidth < centerPos) {
                    this.galleryXPos = 0;
                } else if (
                    currThumbsWidth >
                    this.images.length * this.thumbnailWidth - galleryWidth + centerPos
                ) {
                    this.galleryXPos = -(
                        this.images.length * this.thumbnailWidth -
                        galleryWidth -
                        20
                    );
                } else {
                    this.galleryXPos = -(this.imgIndex * this.thumbnailWidth) + centerPos;
                }
            },
            upperFirst(size){
                return _.upperFirst(size);
            },
        },

        props: ["images", "index"],

        watch: {
            index(val) {
                this.imgIndex = val;
            }
        },
    };

</script>

<style lang="scss">

    $black-alpha-80: rgba(0, 0, 0, 0.8);
    $black: #000;
    $white: #fff;
    $radius-medium: 8px;
    $radius-large: 12px;
    // Breakpoints
    $screen-xs: 480px;
    $screen-sm: 768px;
    $screen-md: 992px;
    $screen-lg: 1200px;
    // So media queries don't overlap when required, provide a maximum
    $screen-xs-max: ($screen-sm - 1);
    $screen-sm-max: ($screen-md - 1);
    $screen-md-max: ($screen-lg - 1);
    @mixin respond-to($media) {
        @if $media==xs {
            @media (max-width: $screen-xs-max) {
                @content;
            }
        } @else if $media==sm {
            @media (min-width: $screen-sm) and (max-width: $screen-sm-max) {
                @content;
            }
        } @else if $media==md {
            @media (min-width: $screen-md) and (max-width: $screen-md-max) {
                @content;
            }
        } @else if $media==lg {
            @media (min-width: $screen-lg) {
                @content;
            }
        }
    }

    @mixin modal-base() {
        transition: opacity 0.2s ease;
        position: fixed;
        z-index: 9998;
    }

    @mixin modal-mask() {
        @include modal-base();
        top: 0;
        left: 0;
        width: 100%;
        min-height: 100%;
        height: 100vh;
        background-color: $black-alpha-80;
        display: table;
    }

    .vgs {
        @include modal-mask();
        &__close {
            color: #fff;
            position: absolute;
            top: 0;
            right: 0;
            background-color: transparent;
            border: none;
            font-size: 25px;
            width: 50px;
            height: 50px;
            cursor: pointer;
            z-index: 999;
            &:focus {
                outline: 0;
            }
        }
        &__prev,
        &__next {
            position: absolute;
            top: 50%;
            margin-top: -25px;
            width: 50px;
            height: 50px;
            z-index: 999;
            cursor: pointer;
            font-size: 40px;
            color: #fff;
            background-color: transparent;
            border: none;
            &:focus {
                outline: 0;
            }
        }
        &__prev {
            left: 0;
        }
        &__next {
            right: 0;
        }
        &__container {
            position: absolute;
            cursor: pointer;
            max-width: 150vh;
            margin: 0.5rem auto 0;
            left: 0.5rem;
            right: 0.5rem;
            height: 60vh;
            @include respond-to(xs) {
                width: 100%;
                max-width: 100%;
                top: 50%;
                margin-top: -140px;
                left: 0;
                right: 0;
                border-radius: 0;
                height: 280px;
            }

            &__section {
                border-radius: $radius-large;
                background-color: $black;
                overflow: hidden;
                height: 84vh;
                text-align:center;
            }

            &__img {
                width:auto;
                height:auto;
                max-width: 100%;
                max-height: 100%;
                object-fit: contain;
            }
        }
    }

    .vgs__gallery {
        @include respond-to(xs) {
            display: none;
        }
        overflow-x: hidden;
        overflow-y: hidden;
        position: absolute;
        bottom: 10px;
        margin: auto;
        max-width: 100vh;
        white-space: nowrap;
        left: 0.5rem;
        right: 0.5rem;
        &__title {
            color: $white;
            margin-bottom: 0.5rem;
        }
        &__container {
            overflow: visible;
            display: block;
            height: 100px;
            white-space: nowrap;
            transition: all 200ms ease-in-out;
            width: 100%;
            &__img {
                width: 100px;
                height: 100px;
                object-fit: cover;
                display: inline-block;
                float: none;
                margin-right: 20px;
                cursor: pointer;
                opacity: 0.6;
                border-radius: $radius-medium;
            }
            &__img--active {
                width: 100px;
                display: inline-block;
                float: none;
                opacity: 1;
            }
        }
    }

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .sizes {
        overflow:hidden;

        > a {
            float:left;
            border:2px solid #000;
            height:90px;
            width:30%;
            margin:1.5%;
            line-height:90px;
            text-align:center;
            color:#000;

            &.active {
                border:2px solid #337ab7 !important;
            }
        }
    }
</style>